import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import Footer from "../Footer/Footer";
import MenuBar from "../MenuBar/MenuBar";
import { blackBoxSingleTitle, themeColors } from "../utils/MUIStylePresets";
import NewsletterSignup from "../utils/SubscribeBox";

export default function NewsletterPage() {
  const ultraMobile = useMediaQuery("(max-width:500px)");

  const scrollToEl = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Stack
      direction="row"
      justifyContent={"center"}
      alignItems={"center"}
      mx={"5%"}
      mt={"2%"}
    >
      <Box maxWidth={1550}>
        <MenuBar scrollToEl={scrollToEl} />
        <Box mt={2}>
          <Box mt={10} id={"Newsletter"}>
            <Typography
              sx={blackBoxSingleTitle}
              color="primary"
              variant={"extrabold"}
            >
              Newsletter pragmatic Ai
            </Typography>
          </Box>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            rowSpacing={2}
            columnSpacing={5}
            mt={ultraMobile ? 1 : 5}
            pl={4}
          >
            <Grid item xs={12}>
              <Typography
                variant={"bookbold"}
                sx={{ color: themeColors("text") }}
                minWidth={200}
              >
                Trop d'AI, pas assez de ROI ? Passez à l'IA concrète 🚀
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant={"book"}
                sx={{ color: themeColors("text") }}
                minWidth={200}
              >
            L'intelligence artificielle vue par ceux qui la déploient, pour ceux qui veulent des résultats
                
              </Typography>
            </Grid>
          </Grid>
          <NewsletterSignup />
        </Box>
        <Box mt={15}>
          <Footer />
        </Box>
      </Box>
    </Stack>
  );
}
